
import Vue from 'vue'

import { ClientPageConfigHeader, HeaderContent, PageThemeCustomization } from '@/types'

import { dateHelper } from '@/helpers/dateHelper'
import { i18n, AVAILABLE_LANGUAGES, TRANSLATED_LANGUAGES } from '@/plugins/i18n'

export default Vue.extend({
  name: 'fo-header-locker-pickup-point',
  props: {
    content: {
      type: Object as () => HeaderContent,
      required: true,
    },
    config: {
      type: Object as () => ClientPageConfigHeader,
      required: true,
    },
    theme: {
      type: Object as () => PageThemeCustomization,
      required: false,
      default: () => ({
        backgroundColor: '#FFFFFF',
      }),
    },
    availableLanguages: {
      type: Array,
      default: () => AVAILABLE_LANGUAGES,
    },
    dataId: {
      type: String,
      required: true,
    },
  },
  data: () => ({ dateHelper }),
  computed: {
    cssGetBackgroundColor() {
      return {
        '--header-bg-color': this.theme.backgroundColor ?? '#FFFFFF',
      }
    },
    countriesNames() {
      return AVAILABLE_LANGUAGES.reduce((languagesNames, language) => {
        languagesNames = { ...languagesNames, [language]: TRANSLATED_LANGUAGES[`${language}`] }
        return languagesNames
      }, {})
    },
    countries() {
      return this.availableLanguages
    },
    showHeader() {
      return Object.values(this.config).some(value => value) || this.availableLanguages.length > 1
    },
  },
  methods: {
    changeLanguage(language: string): void {
      i18n.changeLanguage(language)
      dateHelper.changeLocale(language)
      this.$root.$i18n.i18nLoadedAt = dateHelper.getDate().toString()
      this.$emit('changeLanguage', language)
    },
  },
})
